module.exports = __webpack_public_path__ + "img/measurement_info_left_hands.886c40e6.jpg";